import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-settings-migrate-workflow-action-cell',
  standalone: false,
  templateUrl: './settings-migrate-workflow-action-cell.component.html',
  styleUrls: ['./settings-migrate-workflow-action-cell.component.scss']
})
export class SettingsMigrateWorkflowActionCellComponent {
  @Input() row!: { raw: { id: string } };
  @Output() action = new EventEmitter<{
    action: 'open';
    row: { id: string };
  }>();

  onOpen(event: Event): void {
    event.stopPropagation();
    this.action.emit({ action: 'open', row: this.row.raw });
  }
}
